export function waitForElement(selector: string, isUserGuideSelector: boolean = true) {
  const fullSelector = isUserGuideSelector ? `[data-user-guide-id="${selector}"]` : selector;
  return new Promise(resolve => {
    if (document.querySelector(fullSelector)) {
      return resolve(document.querySelector(fullSelector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(fullSelector)) {
        resolve(document.querySelector(fullSelector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
